import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';

const NoticiaDetailPage = () => {
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  const news = [
    {
      id: 1,
      title: 'O que significa Food Service?',
      excerpt: 'Nova linha de produtos desenvolvida especialmente para atender as demandas do mercado de Food Service com mais praticidade e qualidade.',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/f337a6b15156ffd0f0e4275f2501032b.jpeg',
      category: 'Lançamentos',
      date: '15 de Janeiro, 2026',
      author: 'Equipe Sustentare',
      readTime: '5 min',
      content: `
        <p>O setor de food service é encarregado da produção, preparação e fornecimento de alimentos fora de casa, atendendo desde pequenos negócios até grandes operações de alimentação. Ele abrange todos os estabelecimentos que oferecem alimentos prontos ou semiprontos para consumo imediato ou posterior, priorizando sempre a eficiência, a padronização, a segurança alimentar e a qualidade.O food service inclui restaurantes, lanchonetes, bares, padarias, pizzarias, cafeterias, hotéis, buffets, cozinhas industriais, redes de fast food, serviços de catering, hospitais, escolas, empresas, indústrias e operações de alimentação coletiva. Também estão abrangidos os fornecedores de ingredientes, materiais, equipamentos e soluções criadas especificamente para esse setor.Ao contrário do varejo convencional, o food service requer produtos ajustados para grandes quantidades, com rendimento confiável, facilidade de preparo e estabilidade no sabor e na textura. Portanto, o setor valoriza a inovação, a tecnologia, os processos padronizados e as soluções que economizam tempo, diminuem custos e asseguram uma experiência gastronômica de alta qualidade para o consumidor final.Além de oferecer refeições, o food service promove a conexão entre pessoas, gera experiências e impulsiona a economia, constituindo um dos fundamentos da alimentação contemporânea e um setor em constante transformação, impulsionado por tendências de consumo emergentes, praticidade e excelência.</p>

        <h2>Inovação e Qualidade</h2>
        <p>Os novos produtos foram desenvolvidos após extensas pesquisas de mercado e testes rigorosos de qualidade. Nossa equipe de P&D trabalhou incansavelmente para criar soluções que atendam às necessidades específicas de restaurantes, hotéis e estabelecimentos do setor de Food Service.</p>

        <h2>Principais Características</h2>
        <ul>
          <li><strong>Praticidade:</strong> Produtos prontos para uso, reduzindo tempo de preparo</li>
          <li><strong>Qualidade Superior:</strong> Ingredientes selecionados e processos rigorosos de controle</li>
          <li><strong>Versatilidade:</strong> Aplicações diversas para diferentes tipos de preparações</li>
          <li><strong>Rendimento:</strong> Excelente custo-benefício para operações de grande escala</li>
        </ul>

        <h2>Compromisso com o Mercado</h2>
        <p>Esta nova linha reafirma nosso compromisso em ser o parceiro estratégico ideal para o setor de Food Service. Continuamos investindo em tecnologia, inovação e qualidade para oferecer as melhores soluções do mercado.</p>

        <p>Os produtos já estão disponíveis para pedidos. Entre em contato com nossa equipe comercial para mais informações e condições especiais de lançamento.</p>
      `
    },
    {
      id: 2,
      title: 'Participação da Sustentare na maior feira de alimentos da América Latina',
      excerpt: 'Confira os destaques da nossa participação no evento que reuniu os principais players do setor alimentício.',
      image: 'https://readdy.ai/api/search-image?query=Large%20modern%20food%20industry%20trade%20show%20exhibition%20booth%20with%20professional%20display%20stands%2C%20branded%20materials%20in%20teal%20and%20orange%20colors%2C%20business%20professionals%20networking%20and%20discussing%20products%2C%20bright%20spacious%20convention%20center%20environment%2C%20contemporary%20booth%20design%20with%20product%20samples%20and%20promotional%20materials%2C%20professional%20event%20photography&width=1200&height=600&seq=news-detail-2&orientation=landscape',
      category: 'Eventos',
      date: '08 de Janeiro, 2024',
      author: 'Marketing Sustentare',
      readTime: '4 min',
      content: `
        <p>A Sustentare marcou presença na maior feira de alimentos da América Latina, apresentando suas inovações e fortalecendo parcerias estratégicas com clientes e fornecedores de todo o continente.</p>

        <h2>Destaques do Evento</h2>
        <p>Nosso estande foi um dos mais visitados da feira, recebendo milhares de profissionais interessados em conhecer nossas soluções inovadoras para o mercado de alimentos.</p>

        <h2>Lançamentos Apresentados</h2>
        <ul>
          <li>Nova linha premium para Food Service</li>
          <li>Produtos sustentáveis com embalagens recicláveis</li>
          <li>Soluções personalizadas para marcas próprias</li>
          <li>Ingredientes funcionais de alta performance</li>
        </ul>

        <h2>Networking e Parcerias</h2>
        <p>O evento proporcionou excelentes oportunidades de networking, resultando em novas parcerias comerciais e fortalecimento de relacionamentos existentes. Recebemos feedback extremamente positivo sobre nossos produtos e serviços.</p>

        <h2>Reconhecimento do Mercado</h2>
        <p>A participação na feira reforça nossa posição como referência no setor de alimentos em pó e ingredientes para a indústria alimentícia. Agradecemos a todos que visitaram nosso estande e contribuíram para o sucesso deste evento.</p>
      `
    },
    {
      id: 3,
      title: 'Sustentare investe em energia solar e reduz emissões em 40%',
      excerpt: 'Compromisso com o meio ambiente: nova planta de energia solar instalada em nossa fábrica representa marco importante na sustentabilidade.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20facility%20rooftop%20covered%20with%20solar%20panels%2C%20aerial%20view%20of%20food%20manufacturing%20plant%20with%20sustainable%20energy%20infrastructure%2C%20blue%20sky%20background%2C%20clean%20technology%20integration%2C%20environmental%20responsibility%20concept%2C%20professional%20architectural%20photography%20with%20teal%20and%20orange%20color%20accents%2C%20bright%20sunny%20day%20showing%20renewable%20energy%20in%20action&width=1200&height=600&seq=news-detail-3&orientation=landscape',
      category: 'Sustentabilidade',
      date: '02 de Janeiro, 2024',
      author: 'Sustentabilidade',
      readTime: '6 min',
      content: `
        <p>A Sustentare dá mais um passo importante em sua jornada de sustentabilidade com a instalação de uma moderna planta de energia solar em suas instalações. O investimento representa um marco significativo em nosso compromisso com o meio ambiente.</p>

        <h2>Impacto Ambiental</h2>
        <p>A nova planta solar é capaz de gerar energia suficiente para suprir grande parte das necessidades de nossa operação, resultando em uma redução de 40% nas emissões de carbono. Este é um dos maiores projetos de energia renovável no setor de alimentos em pó do Brasil.</p>

        <h2>Investimento em Tecnologia Limpa</h2>
        <ul>
          <li>Mais de 2.000 painéis solares instalados</li>
          <li>Capacidade de geração de 1.2 MW</li>
          <li>Redução de 40% nas emissões de CO2</li>
          <li>Economia anual estimada de R$ 800 mil em energia</li>
        </ul>

        <h2>Compromisso de Longo Prazo</h2>
        <p>Este investimento faz parte de nossa estratégia de sustentabilidade de longo prazo, que inclui metas ambiciosas de redução de emissões e uso de recursos naturais. Estamos comprometidos em ser uma empresa carbono neutro até 2030.</p>

        <h2>Responsabilidade Social</h2>
        <p>Além dos benefícios ambientais, o projeto também contribui para a economia local, gerando empregos durante a instalação e manutenção do sistema. Continuaremos investindo em tecnologias limpas e práticas sustentáveis em todas as nossas operações.</p>
      `
    },
    {
      id: 4,
      title: 'Tecnologia de ponta: Sustentare implementa IA no controle de qualidade',
      excerpt: 'Inovação tecnológica garante ainda mais precisão e segurança em todos os processos produtivos.',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20food%20quality%20control%20laboratory%20with%20artificial%20intelligence%20monitoring%20systems%2C%20modern%20digital%20screens%20displaying%20data%20analytics%2C%20scientists%20in%20white%20lab%20coats%20using%20high-tech%20equipment%2C%20futuristic%20food%20testing%20facility%2C%20clean%20sterile%20environment%20with%20blue%20LED%20lighting%2C%20professional%20technology%20photography%20showing%20innovation%20in%20food%20safety&width=1200&height=600&seq=news-detail-4&orientation=landscape',
      category: 'Inovação',
      date: '28 de Dezembro, 2023',
      author: 'P&D Sustentare',
      readTime: '7 min',
      content: `
        <p>A Sustentare implementa sistema de Inteligência Artificial para controle de qualidade, elevando ainda mais os padrões de segurança e excelência em seus processos produtivos. A tecnologia representa um salto qualitativo na garantia da qualidade de nossos produtos.</p>

        <h2>Tecnologia de Ponta</h2>
        <p>O novo sistema utiliza algoritmos avançados de machine learning para monitorar em tempo real todos os parâmetros críticos de qualidade durante o processo produtivo. A IA é capaz de detectar variações mínimas que poderiam passar despercebidas pelo controle tradicional.</p>

        <h2>Benefícios da Implementação</h2>
        <ul>
          <li><strong>Precisão:</strong> Detecção de variações com precisão 99.9%</li>
          <li><strong>Velocidade:</strong> Análise em tempo real de todos os lotes</li>
          <li><strong>Rastreabilidade:</strong> Registro completo de todos os parâmetros</li>
          <li><strong>Prevenção:</strong> Identificação precoce de possíveis desvios</li>
        </ul>

        <h2>Investimento em Inovação</h2>
        <p>O projeto representa um investimento de R$ 2 milhões em tecnologia e capacitação de equipe. Nossos colaboradores receberam treinamento especializado para operar e interpretar os dados gerados pelo sistema de IA.</p>

        <h2>Resultados Esperados</h2>
        <p>Com a implementação completa do sistema, esperamos reduzir ainda mais os índices de não conformidade e aumentar a eficiência operacional. A tecnologia também permitirá otimizações contínuas nos processos, resultando em produtos de qualidade ainda superior.</p>

        <h2>Futuro da Qualidade</h2>
        <p>Este é apenas o primeiro passo em nossa jornada de transformação digital. Continuaremos investindo em tecnologias emergentes para manter nossa posição de liderança em qualidade e inovação no setor de alimentos.</p>
      `
    },
    {
      id: 5,
      title: 'Sustentare expande atuação para novos mercados internacionais',
      excerpt: 'Produtos brasileiros conquistam consumidores em países da África e Ásia com qualidade e inovação.',
      image: 'https://readdy.ai/api/search-image?query=International%20business%20expansion%20concept%20with%20world%20map%2C%20cargo%20containers%20and%20shipping%20logistics%2C%20global%20food%20distribution%20network%2C%20modern%20warehouse%20with%20international%20flags%2C%20professional%20business%20photography%20showing%20export%20operations%2C%20teal%20and%20orange%20branded%20products%20ready%20for%20international%20shipping%2C%20contemporary%20corporate%20imagery&width=1200&height=600&seq=news-detail-5&orientation=landscape',
      category: 'Lançamentos',
      date: '20 de Dezembro, 2023',
      author: 'Exportação',
      readTime: '5 min',
      content: `
        <p>A Sustentare anuncia a expansão de suas operações para novos mercados internacionais, consolidando sua presença em países da África e Ásia. Esta expansão representa um marco importante na internacionalização da empresa.</p>

        <h2>Novos Mercados</h2>
        <p>Após rigoroso processo de certificação e adequação às normas locais, nossos produtos já estão sendo comercializados em 8 novos países, incluindo Angola, Moçambique, Vietnã e Filipinas.</p>

        <h2>Estratégia de Expansão</h2>
        <ul>
          <li>Parcerias com distribuidores locais estabelecidos</li>
          <li>Adequação de produtos às preferências regionais</li>
          <li>Certificações internacionais de qualidade</li>
          <li>Suporte técnico e comercial local</li>
        </ul>

        <h2>Qualidade Brasileira no Mundo</h2>
        <p>Nossos produtos têm sido muito bem recebidos nos novos mercados, com destaque para a linha de caldos, temperos e ingredientes funcionais. A qualidade e o custo-benefício dos produtos brasileiros têm conquistado consumidores e empresas em todo o mundo.</p>

        <h2>Perspectivas Futuras</h2>
        <p>A expansão internacional faz parte de nossa estratégia de crescimento de longo prazo. Estamos em negociação com distribuidores de outros países e esperamos dobrar nossa presença internacional nos próximos dois anos.</p>

        <h2>Compromisso Global</h2>
        <p>Mesmo com a expansão internacional, mantemos nosso compromisso com a qualidade, sustentabilidade e inovação que sempre caracterizaram a Sustentare. Continuaremos levando o melhor da indústria alimentícia brasileira para o mundo.</p>
      `
    },
    {
      id: 6,
      title: 'Workshop gratuito: Tendências em Food Service para 2024',
      excerpt: 'Evento exclusivo para clientes e parceiros apresenta as principais tendências do mercado para o próximo ano.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20workshop%20in%20modern%20conference%20room%2C%20food%20service%20industry%20professionals%20attending%20presentation%2C%20speaker%20presenting%20trends%20and%20insights%20on%20large%20screen%2C%20contemporary%20meeting%20space%20with%20comfortable%20seating%2C%20bright%20natural%20lighting%2C%20engaged%20audience%20taking%20notes%2C%20professional%20event%20photography%20with%20teal%20and%20orange%20branding%20elements&width=1200&height=600&seq=news-detail-6&orientation=landscape',
      category: 'Eventos',
      date: '15 de Dezembro, 2023',
      author: 'Eventos Sustentare',
      readTime: '4 min',
      content: `
        <p>A Sustentare realizou workshop exclusivo para clientes e parceiros, apresentando as principais tendências do mercado de Food Service para 2024. O evento reuniu mais de 200 profissionais do setor em um dia repleto de conteúdo e networking.</p>

        <h2>Principais Temas Abordados</h2>
        <p>O workshop contou com palestras de especialistas renomados do mercado, abordando temas como inovação em cardápios, sustentabilidade, tecnologia e gestão de custos no Food Service.</p>

        <h2>Tendências para 2024</h2>
        <ul>
          <li><strong>Plant-Based:</strong> Crescimento de opções vegetais e veganas</li>
          <li><strong>Sustentabilidade:</strong> Práticas eco-friendly e redução de desperdício</li>
          <li><strong>Tecnologia:</strong> Automação e digitalização de processos</li>
          <li><strong>Experiência:</strong> Foco na experiência completa do cliente</li>
        </ul>

        <h2>Demonstrações Práticas</h2>
        <p>Além das palestras, o evento incluiu demonstrações práticas de preparações utilizando produtos Sustentare, mostrando aplicações inovadoras e técnicas de otimização de processos.</p>

        <h2>Networking e Parcerias</h2>
        <p>O workshop proporcionou excelentes oportunidades de networking entre profissionais do setor, resultando em trocas de experiências valiosas e novas parcerias comerciais.</p>

        <h2>Próximos Eventos</h2>
        <p>Devido ao sucesso desta edição, já estamos planejando novos workshops para 2024. Fique atento às nossas redes sociais e newsletter para não perder as próximas oportunidades de capacitação e networking.</p>
      `
    }
  ];

  const currentNews = news.find(item => item.id === Number(id));

  if (!currentNews) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Notícia não encontrada</h1>
          <Link to="/noticias" className="text-blue-600 hover:text-blue-700 font-semibold whitespace-nowrap cursor-pointer">
            Voltar para notícias
          </Link>
        </div>
      </div>
    );
  }

  const relatedNews = news.filter(item => item.id !== currentNews.id).slice(0, 3);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Image */}
      <div className="w-full h-96 lg:h-[500px] overflow-hidden">
        <img 
          src={currentNews.image}
          alt={currentNews.title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Article Content */}
      <article className="max-w-4xl mx-auto px-4 py-16">
        {/* Meta Info */}
        <div className="mb-8">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            {currentNews.title}
          </h1>
          <div className="flex flex-wrap items-center gap-6 text-gray-600">
            <span className="flex items-center gap-2">
              <i className="ri-calendar-line"></i>
              {currentNews.date}
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-user-line"></i>
              {currentNews.author}
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              {currentNews.readTime} de leitura
            </span>
          </div>
        </div>

        {/* Article Body */}
        <div 
          className="prose prose-lg max-w-none"
          dangerouslySetInnerHTML={{ __html: currentNews.content }}
          style={{
            fontSize: '1.125rem',
            lineHeight: '1.75',
            color: '#374151'
          }}
        />
      </article>

      {/* Related News - REMOVED */}
    </div>
  );
};

export default NoticiaDetailPage;